import type {SpotfightEvent} from "./models";

export const LEAGUE_WWE = "WWE";
export const LEAGUE_NXT = "NXT";
export const LEAGUE_AEW = "AEW";
export const LEAGUE_LONG_TERM = "LONG_TERM";

export const ALL_LEAGUES = [LEAGUE_WWE, LEAGUE_NXT, LEAGUE_AEW, LEAGUE_LONG_TERM];
export const SCOREBOARD_LEAGUES = [LEAGUE_WWE, LEAGUE_NXT, LEAGUE_AEW];

export function leagueLabel(league: string): string {
  if (league === LEAGUE_LONG_TERM) {
    return "Langzeit-Tipp";
  }

  return league;
}

export function isLongTermEvent(event: SpotfightEvent): boolean {
  return event.league === LEAGUE_LONG_TERM;
}
